import { create } from "zustand";
import { persist } from "zustand/middleware";

type AnonymousTokenStore = {
  token: string | null;
  identifier: string | number | null;
  isLoggedIn: () => boolean;
  login: (token: string, identifier: string | number) => void;
  logout: () => void;
};

export const useAnonymousToken = create<AnonymousTokenStore>()(
  persist(
    (set, get) => ({
      token: null,
      identifier: null,
      logout: () => set({ token: null, identifier: null }),
      login: (token: string, identifier: string | number) => set({ token, identifier }),
      isLoggedIn: () => {
        const { token, identifier } = get();
        return !!token && !!identifier;
      },
    }),
    {
      name: "anonymous-token",
    },
  ),
);
